import { extendTheme } from '@chakra-ui/react';
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

export const theme = extendTheme({
  initialColorMode: 'light',
  useSystemColorMode: false,
  fonts: {
    heading: `Barlow, -apple-system, Helvetica, sans-serif`,
    body: `Barlow, -apple-system, Helvetica, sans-serif`,
  },
  styles: {
    global: (props: StyleFunctionProps) => ({
      body: {
        color: mode('gray.800', 'whiteAlpha.900')(props),
        bg: mode('#f5f2ed', 'gray.800')(props),
      },
    }),
  },
});
